import axios, { AxiosInstance } from "axios";
import {
  AlreadyExistsError,
  IntegrationError,
  InvalidUserOrPasswordError,
  NotAuthenticatedError,
  NotFoundError,
  UnauthorizedError,
  UnexpectedError,
  ValidationError,
} from "../../errors";

const API_URL = import.meta.env.VITE_LINK_API;
export const TOKEN_KEY = "jwt_token";

export const api: AxiosInstance = axios.create({
  baseURL: API_URL,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem(TOKEN_KEY);
  const clientId = localStorage.getItem("clientId") ?? "";
  const usinaId = localStorage.getItem("usinaId") ?? "";

  if (token) {
    config.headers["Authorization"] = `Bearer ${token}`;
    config.headers["ClientId"] = clientId;
    config.headers["UsinaId"] = usinaId;
  }

  return config;
});

api.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    if (error.response.status === 401) {
      throw new NotAuthenticatedError(error.response.data.detail || undefined);
    }
    if (error.response.status === 403) {
      throw new UnauthorizedError(error.response.data.detail || undefined);
    }
    if (error.response.status === 404) {
      throw new NotFoundError(error.response.data.detail || undefined);
    }
    if ((error.response.status = 409)) {
      throw new AlreadyExistsError(error.response.data.detail || undefined);
    }
    if ((error.response.data.status = 422)) {
      throw new ValidationError(error.response.data.detail || undefined);
    }
    if (error.response.status === 424) {
      throw new IntegrationError(error.response.data.detail || undefined);
    }

    if (error.response.data.detail == "Usuário ou senha inválidos") {
      throw new InvalidUserOrPasswordError();
    }
    throw new UnexpectedError();
  }
);

export default api;
